export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4099f2478320441663b89fb79ecb2478b1a4bcb0cf&name=revalidateCommunity!'